import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { PanelContent } from '../../../components/panel-content'
import { useStateValue } from '../../../components/state'
import { Video } from '../../../components/video'
import { Button } from '../../../components/button'
import { useDelayedBoolean } from '../../../hooks/use-delayed-boolean'
import { MapFact } from '../../../components/map-fact'

export const GroundwaterReplenishment: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to desalination
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'wastewater-treatment' }
    })
  }, [dispatch])

  const factVisible = useDelayedBoolean({ delay: 500 })

  return (
    <PanelContent>
      <h1>Groundwater replenishment</h1>
      <p>
        Groundwater replenishment is where wastewater is treated to the highest
        drinking water standards, and then recharged into our groundwater
        supplies. Our Beenyup (Craigie) wastewater treatment plant is the first
        plant to support groundwater replenishment and has the capacity to
        recycle up to 28 billion litres of water a year - that's enough to
        supply up to 100,000 households! Half of this water is recharged to the
        Leederville and Yarragardee Quifers onsite, the other half is recharged
        into aquifers in Wanneroo and Neerabup.
      </p>
      <Video videoId='7oVd9guE7Mw' />
      <MapFact
        aboveValue='Other parts of the world, such as Orange County in the US and Singapore have been successfully recycling water for drinking for many years.'
        visible={factVisible}
        position='top-right'
      />
      <Button href='https://www.watercorporation.com.au/Our-water/Groundwater/Groundwater-replenishment'>
        Learn more about groundwater replenishment
      </Button>
    </PanelContent>
  )
}
